module.exports = __webpack_public_path__ + "static/media/playbtn_small.a8d5b43c.svg";